module.exports = __webpack_public_path__ + "img/mine-active.07101b15.png";